

































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { Subscription } from 'vue-rx-decorators';
import TabsComponent from './tabs.vue';
import { Sites, Inmates, User, InmateSource, CanvasAccounts } from '@lantern/lantern-sdk';
import { RouteNames } from './_routes';
import { router } from '../../main';
import { InmateSelected, CoursesSelected, Titles, CourseListItem, Cache } from '@/common/cache';
import { alert } from '@/common/modal';
import { log } from 'util';

interface InmateListItem extends Inmates.Document {
  selected: boolean;
}

enum DisplayErrors {
  loadInmatesError = 'Error: cannot load Inmates',
}

export enum EducationPermission {
    educationAny = 'any',
    educationEnable = 'enabled',
    educationDisable = 'disabled'
 }

const DEFAULT_PAGE_SIZE = 100;

@Component({
    components: {
        tabs: TabsComponent,
        //       Datepicker
    },
})
export default class InmatesComponent extends Vue {

  inmates: InmateListItem[] | null = null;
  lastInmatesSelected: string | null = null; // to display single added inmate;
  inmatesSelected: InmateSelected = this.$cache.inmatesSelected.value; // "152845:CHRISTOPHER:DROUIN:false:027395" or "152845:CHRISTOPHER:DROUIN:false:undefined" id:firstName:LastName:tabletShipt:sviscustodyAccout
  count: number | null = null;
  pageNumber = 1;
  pageSize = 20;
  pages: number | null = null;
  page = 0;
  loading = true;

  source: string = '';
  jpay = InmateSource.jpay;

  countCourses: number = 0;
  coursesPageNumber = 1;
  coursesPageSize = 50;
  coursesSelected: CoursesSelected = {}; // courseID : SectionID

  sites: Sites.Document[] | null = null;
  selectedSite: Sites.Document | null = null;

  has7InchTablet = false;
  isRegistered: boolean = false;

  educationPermission: EducationPermission | null = null;
  educationAny = EducationPermission.educationAny;
  educationEnable = EducationPermission.educationEnable;
  educationDisable = EducationPermission.educationDisable;

  displayError: DisplayErrors | null = null;
  mainLoader: boolean = true;

  // view Mode
  singleStudents: boolean = false; // allowed user to see list of inmates or register them only by name and id
  accessMode: CanvasAccounts.RegistrationAccessMode | null = null;
  typeSingleStudent = CanvasAccounts.RegistrationAccessMode.singleStudents;
  // end view Mode

  single: any = {
      id: '',
      firstName: '',
      lastName: '',
      search: this.searchSingleStudent,
  }

  modal: any = {
      enroll: {
          show: false,
          cancel: this.enrollCancel,
          submit: this.enrollSubmit,
          create: this.createSection,
          change: this.changeSection
      },
      register: {
          locked: false,
          show: false,
          cancel() {},
          submit() {},
      },
      selected: {
          locked: false,
          show: false,
      },
      section: {
          show: false,
          params: {},
          cancel: this.sectionClose,
          submit: this.sectionClose,
      }
  };

  tempDesabled = true;

  @Subscription(() => Cache.instance.accounts)
  accounts!: User.CanvasAccounts | { mainAccounts: []; subAcccounts: [] };

  @Subscription(() => Cache.instance.coursesArray)
  coursesArray!: CourseListItem[] | [];

  selectedCount() {
      let selected = 0;
      for (const site in this.inmatesSelected) {
          if (this.inmatesSelected.hasOwnProperty(site)) {
              selected += this.inmatesSelected[site].length;
          }
      }
      return selected;
  }

    @Subscription(() => Cache.instance.isAdmin)
    isAdmin!: boolean | null;

    async created() {

        // check access only for not rouote admins
        if (!this.isAdmin) {
            const res = await this.$lantern.endpoints.User.accessMode(this.$route.params.facilityId);
            console.log('RegistrationAccessMode' ,CanvasAccounts)
            console.log('AccessMode' ,res)


            // in case some crazy glitches
            this.accessMode = res.data.access;
            if (!res.data.access) {
                console.log('Access not set for curent user!'); router.push({ name: RouteNames.facilities }); return;
            }

            if (this.accessMode === CanvasAccounts.RegistrationAccessMode.singleStudents) this.singleStudents = true;
            this.mainLoader = false;
        }

        this.source = this.$route.params.facilityId.split(':')[0];
        if (!this.singleStudents) {
            this.mainLoader = true;
            await this.loadInmates();
            await this.loadSites();
        }

        this.clearAllSelectedInmates();
    }

    // #region INMATES
    async loadSites() {
        try {
            const facilityId = this.$route.params.facilityId;
            const query: any = { facilityId, pageSize: DEFAULT_PAGE_SIZE, pageNumber: 0 };
            const response = await this.$lantern.endpoints.Sites.list(query);
            this.sites = response.data.sites;

        } catch (error: any) {
            await alert(error.message);
            this.mainLoader = false;
        }
    }

    isSelected(inmate: Inmates.Document) {
        if (this.inmatesSelected[inmate.siteId]) {
            const NameSelected = this.getSelectedName(inmate);
            return this.inmatesSelected[inmate.siteId].indexOf(NameSelected) !== -1;
        }
        return false;

    }

    async loadInmates() {
        this.loading = true;

        try {
            console.log(`loadInmates`);

            const facilityId = this.$route.params.facilityId;
            const query: Parameters<typeof Inmates.list> = [{ facilityId, pageSize: this.pageSize, pageNumber: this.pageNumber }];
            if (this.selectedSite) query[0].siteId = this.selectedSite.id;
            if (this.has7InchTablet) query[0].has7InchTablet = true;
            if (this.educationPermission) query[0].educationPermission = this.educationPermission;
            if (this.isRegistered) query[0].isRegistered = this.isRegistered;

            const response = await this.$lantern.endpoints.Inmates.list(...query);
            console.log(response);

            this.inmates = response.data.inmates.map((inmate) => ({ ...inmate, selected: this.isSelected(inmate) }));

            this.count = response.data.total;
            this.pages = Math.ceil(this.count / this.pageNumber);
            this.loading = false;
            this.mainLoader = false;

            this.displayError = null;
        } catch (error) {
            this.displayError = DisplayErrors.loadInmatesError;
            this.loading = false;
            this.mainLoader = false;
            this.inmates = null;
        }
        console.log(this.inmates);

    }

    getSelectedName(inmate: Inmates.Document) {
        return `${inmate.id}:${inmate.firstName}:${inmate.lastName}:false:${inmate.sviscustodyAccout}`; // we use the last param for shipTablet check box on the confirmation page
    }

    addSingleInmate(inmate: Inmates.Document, selected: boolean) {
        if (!this.inmatesSelected[`${inmate.siteId}`]) this.inmatesSelected[`${inmate.siteId}`] = [];

        const NameSelected = this.getSelectedName(inmate);
        if (selected) {
            if (this.inmatesSelected[`${inmate.siteId}`].indexOf(NameSelected) === -1) this.inmatesSelected[`${inmate.siteId}`].push(NameSelected);
        } else {
            this.inmatesSelected[`${inmate.siteId}`] = this.inmatesSelected[`${inmate.siteId}`].filter((e) => e !== NameSelected);
            if (this.inmatesSelected[`${inmate.siteId}`].length === 0) delete this.inmatesSelected[`${inmate.siteId}`];
        }
        this.$cache.inmatesSelected.next(this.inmatesSelected);
    }

    getFilterqdQuerry(pageNumber: number) {
        const facilityId = this.$route.params.facilityId;
        const query: Parameters<typeof Inmates.list> = [{ facilityId, pageSize: 500, pageNumber }];
        if (this.selectedSite) query[0].siteId = this.selectedSite.id;

        return query;
    }

    changeAllInmateFlags(changeTo: boolean) {
        if (this.inmates) {
            for (const inmate of this.inmates) {
                inmate.selected = changeTo;
            }
        }
    }

    async addAllFiltredInmates() {
        // count - tottal records for filtered list
        // 500 - total posible records pere request
        this.loading = true;

        if (this.count) {
            const requests = Math.ceil(this.count / 500);

            for (let i = 0; i < requests + 1; i++) {
                const query = this.getFilterqdQuerry(i);
                // eslint-disable-next-line no-await-in-loop
                const response = await this.$lantern.endpoints.Inmates.list(...query);

                for (const inmate of response.data.inmates) {
                    this.addSingleInmate(inmate, true);
                }
            }
            this.changeAllInmateFlags(true);
        }
        this.loading = false;

    }

    async clearAllFiltredInmates() {
        if (this.count && Object.keys(this.inmatesSelected).length !== 0) {
            const requests = Math.ceil(this.count / 500);

            for (let i = 0; i < requests; i++) {
                const query = this.getFilterqdQuerry(i);
                // eslint-disable-next-line no-await-in-loop
                const response = await this.$lantern.endpoints.Inmates.list(...query);

                for (const inmate of response.data.inmates) {
                    this.addSingleInmate(inmate, false);
                }
            }
            this.changeAllInmateFlags(false);
        }
    }

    clearAllSelectedInmates() {
        this.inmatesSelected = {};
        this.changeAllInmateFlags(false);
    }

    @Watch('pageNumber')
    onPageNumberChanged(val: string, oldVal: string) {
        this.loadInmates();
    }

    @Watch('selectedSite')
    onSelectedSiteChanged(val: string, oldVal: string) {
        this.loadInmates();
    }

    @Watch('has7InchTablet')
    onHas7InchTabletChanged(val: string, oldVal: string) {
        this.loadInmates();
    }

    @Watch('educationPermission')
    onEducationPermissionChanged(val: string, oldVal: string) {
        this.loadInmates();
    }

    @Watch('isRegistered')
    onisRegisteredChanged(val: string, oldVal: string) {
        this.loadInmates();
    }
    // #endregion INMATES block

    // #region COURSES LOADER
    async enrollInCourses() {
        if (Object.keys(this.inmatesSelected).length === 0) {
            await alert('Please pick students first!');
            return;
        }
        this.modal.enroll.show = true;
    }

    async enrollSubmit() {
        this.modal.enroll.show = false;
        router.push({ name: RouteNames.confirmation, params: { title: Titles.studentsEnrollment } });
    }

    async enrollCancel() {
        this.modal.enroll.show = false;
    }
    // #endregion COURSES HENDLERS

    // #region SECTIONS
    changeSection(course: CourseListItem) {
        this.modal.section.show = true;
        this.modal.section.params = { course, create: false };
    };

    createSection(course: CourseListItem) {
        this.modal.section.show = true;
        this.modal.section.params = { course, create: true };
    }

    sectionClose() {
        this.modal.section.show = false;
    }
    // #endregion SECTIONS block

    // #region SINGLE SEARCH
    async searchSingleStudent() {

        // we nedd only id - but requirement to fill up all fields
        if (this.single.id.trim() === '' || this.single.firstName.trim() === '' || this.single.lastName.trim() === '') {
            await alert('Please fill out all fields!');
            return;
        }

        // new requirement for custodyAccout instead of ID for SVIS
        const id = `${this.source}:${this.single.id.trim()}:${this.$route.params.facilityId}`;

        let response;
        let inmate = null;
        try {
            if (this.source === this.jpay) {
                response = await this.$lantern.endpoints.Inmates.get(id, { firstName: this.single.firstName, lastName: this.single.lastName });
            } else {
                response = await this.$lantern.endpoints.Inmates.getByCustodyAccout(id, { firstName: this.single.firstName, lastName: this.single.lastName });
            }

            inmate = response.data;

            if (inmate) {
                const NameSelected = this.getSelectedName(inmate);
                this.lastInmatesSelected = NameSelected;
                let showName = `Inmate id: ${NameSelected.split(':')[4]}, Name: ${NameSelected.split(':')[1]} ${NameSelected.split(':')[2]}`;
                if (this.source === this.jpay) {
                    showName = `Inmate id:${NameSelected.split(':')[0]}, Name: ${NameSelected.split(':')[1]} ${NameSelected.split(':')[2]}`;
                }
                this.addSingleInmate(inmate, true);
                this.$cache.inmatesSelected.next(this.inmatesSelected);
                await alert(`Inmate was added! ${showName}`);
            } else {
                await alert('Inmate not found');
            }

        } catch (error) {
            await alert('Inmate not found');
        }

    }
    // #endregion SINGLE SEARCH BLOCK

    async navigateToConfirmation() {
        if (Object.keys(this.inmatesSelected).length === 0) {
            await alert('Please pick students first!');
            return;
        }
        console.log(this.inmatesSelected);

        router.push({ name: RouteNames.confirmation, params: { title: Titles.studentsOnly } });
    }
}
